export const accountMigrationDiagnosticDataDescription = "kqdcD";
export default {accountMigrationDiagnosticDataDescription};